import PaperLayout from "./PaperLayout";
export default PaperLayout;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/PaperLayout/index.ts